import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'mc-empty',
    templateUrl: './empty.component.html',
    styleUrls: ['./empty.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class EmptyComponent { }
